import * as THREE from 'three';
import { Lights } from '../objects/Lights';
import { ScrollAnimatedObject } from '../objects/ScrollAnimatedObject';
import { ScrollController } from '../utils/ScrollController';

export class SceneManager {
  private scene: THREE.Scene;
  private lights: Lights;
  private scrollAnimatedObject: ScrollAnimatedObject;
  private _scrollController: ScrollController;
  private lastTime: number = 0;

  constructor(scrollController: ScrollController) {
    this.scene = new THREE.Scene();
    this._scrollController = scrollController;
    void this._scrollController; // Mark as intentionally used
    this.lights = new Lights();
    this.scrollAnimatedObject = new ScrollAnimatedObject(scrollController);
  }

  public setup(): void {
    // Set transparent background for hero section overlay
    this.scene.background = null;

    // Add fog for depth
    this.scene.fog = new THREE.Fog(0x667eea, 5, 30);

    // Add lights
    this.lights.addToScene(this.scene);

    // Add scroll-animated object
    this.scene.add(this.scrollAnimatedObject.getGroup());
  }

  public update(): void {
    const currentTime = performance.now();
    const deltaTime = (currentTime - this.lastTime) / 1000;
    this.lastTime = currentTime;

    // Update scroll-animated object
    this.scrollAnimatedObject.update(deltaTime);
  }

  public getScene(): THREE.Scene {
    return this.scene;
  }

  public dispose(): void {
    this.scrollAnimatedObject.dispose();
    
    // Clean up resources
    this.scene.traverse((object) => {
      if (object instanceof THREE.Mesh) {
        object.geometry.dispose();
        if (Array.isArray(object.material)) {
          object.material.forEach((material) => material.dispose());
        } else {
          object.material.dispose();
        }
      }
    });
  }
}
